import { useEffect, useState } from "react"

export function useFetch (url=""){
    
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {

        const fetchData = async () => {
            setIsLoading(true)
            try{
                await fetch(url)
                .then((response) => (response.json()))
                .then((json) => setData(json))
                .catch(setError(true))
                .finally(setIsLoading(false))

            }
            catch{
                setError(true)
                setIsLoading(false)
            }
        }

        if(url!=="")fetchData();

    }, [url])



    return { data, isLoading, error }

}

  